import dayjs from 'dayjs';
import * as R from 'ramda';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// utilities
import * as U from '../../utilities';
// constants
import { DEFAULT_DATE_TIME_FORMAT } from '../../constants';
// ui
import { StyledDatePicker } from './ui';
//////////////////////////////////////////////////

const DatePicker = ({
  name,
  label,
  value,
  theme,
  maxDate,
  minDate,
  disabled,
  onChange,
}) => {
  const defaultValue = U.ifElse(value, dayjs(value), null);

  const setDate = value => {
    const dateTimeString = U.stringifyAndParseJson(value);

    if (R.not(dateTimeString)) {
      onChange(name, null);

      return;
    }

    onChange(name, dateTimeString);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer sx={{ p: 0 }} components={['DatePicker']}>
        <StyledDatePicker
          label={label}
          theme={theme}
          maxDate={maxDate}
          minDate={minDate}
          onChange={setDate}
          disabled={disabled}
          data-testid='datePicker'
          defaultValue={defaultValue}
          inputFormat={DEFAULT_DATE_TIME_FORMAT}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default DatePicker;
